export default "__VITE_ASSET__DBl_80je__"